export default __webpack_public_path__ + "static/asana-b5146e5ddd80e3d430a2f61dab3f536d.svg";